import { useParams } from "react-router-dom";
import {
  ROUTE_SLUGS,
  RouteKey,
  VALID_LANGS,
  LangCode,
  buildLangPath,
} from "../constants/route-slugs";

/**
 * Returns a function that builds a localized absolute path.
 * Usage: const lp = useLangPath(); lp('tariffs') → '/az/tarifler'
 */
export const useLangPath = () => {
  const { lang } = useParams<{ lang: string }>();
  const currentLang = (
    lang && VALID_LANGS.includes(lang as LangCode) ? lang : "az"
  ) as LangCode;

  return (routeKey: RouteKey): string => buildLangPath(currentLang, routeKey);
};

/**
 * Returns the current lang from URL params.
 */
export const useLang = (): LangCode => {
  const { lang } = useParams<{ lang: string }>();
  return (lang && VALID_LANGS.includes(lang as LangCode) ? lang : "az") as LangCode;
};
